import mountChat from './chat';
import mountGift from './gift';
import { mountGiftGoal, mountCountGoal } from './goal';
import createLatestEventMounter from './latestEvent';
import mountViewerCount from './viewerCount';
import mountHighlightedMessage from './highlightedMessage';
import mountScroller from './scroller';
import mountEmoteWall from './emoteWall';
import mountBanReaper from './banReaper';
import mountWordCloud from './wordCloud';
import mountCamera from './camera';
import mountSpeaker from './speaker';
import mountCameraGrid from './cameraGrid';
import { createChatWidgetSettings } from '../chatSettings';

// widget_type slug -> mount(host). Each mounter builds the widget, wires it to the shared socket via the host
// and registers its own cleanup; the same function serves widget/*.html pages and overlay layers.
export const WIDGET_MOUNTERS = {
	'chat': mountChat,
	'chat-vertical': host => mountChat(host, s => createChatWidgetSettings('chat-vertical', s)),
	'chat-horizontal': host => mountChat(host, s => createChatWidgetSettings('chat-horizontal', s)),
	'gift': mountGift,
	'gift-goal': mountGiftGoal,
	'sub-goal': mountCountGoal,
	'follower-goal': mountCountGoal,
	'latest-follower': createLatestEventMounter('latest-follower'),
	'latest-subscriber': createLatestEventMounter('latest-subscriber'),
	'latest-donation': createLatestEventMounter('latest-donation'),
	'top-donation': createLatestEventMounter('top-donation'),
	'viewer-count': mountViewerCount,
	'highlighted-message': mountHighlightedMessage,
	'scroller': mountScroller,
	'emote-wall': mountEmoteWall,
	'ban-reaper': mountBanReaper,
	'word-cloud': mountWordCloud,
	'camera': mountCamera,
	'speaker': mountSpeaker,
	'camera-grid': mountCameraGrid,
};
